import ScrollableListTable from './ScrollableListTable';

export default ScrollableListTable;
